import { Component } from '@angular/core';

import { StepComponent } from "../step/step.component";
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-quote-layout',
  imports: [HeaderComponent, StepComponent, RouterOutlet],
  templateUrl: './quote-layout.component.html',
  styleUrl: './quote-layout.component.css'
})
export class QuoteLayoutComponent {

}
